const NotFoundTitle = ({ title = "No Data found." }) => {
  return (
    <div className="card justify-content-center mx-4" style={{minHeight:'400px'}}>
    <div className="d-flex justify-content-center align-items-center h-100">
      <h6 className="m-0 text-center">{title}</h6>
    </div>
    </div>
  );
};

export default NotFoundTitle;
